module.exports = __webpack_public_path__ + "media/favicon/mstile-144x144-b7fa79947b41918e2004914c314e4353.png";